import React, { useState } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import { Edit, Edit2, Hourglass, Trash } from "lucide-react";
import Modal from "../../../../organisms/modals/Modal";
import TimePicker from "../../../../atoms/TimePicker";
import { Form } from "formik";
import * as Yup from "yup";
import { DateSelector } from "../../../../organisms/MonthYearSelector";
import { Formik } from "formik";
import SelectDropdown from "../../../../molecules/Dropdown";
import { useCookies } from "react-cookie";
import { decodeCookieValue } from "../../../../../helpers/cookieHelper";
import CircleAvatar from "../../../../atoms/CircleAvatar";
import "./styles.scss";
import moment, { duration } from "moment";
import { deleteData, patchData, postData } from "../../../../../services";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../assets/styles/toast";
import DeleteModal from "../../../../organisms/modals/DeleteModal";
import ConfirmModal from "../../../../organisms/modals/ConfirmModal";
import MuiTimePicker from "../../../../atoms/MuiTimePicker";

const validationSchema = Yup.object().shape({
  date: Yup.date().required("Date is required"),
  elapsed_time: Yup.number()
    .min(1, "Time must be greater than 0")
    .required("Required"),
  employee_id: Yup.string().required("Select an assignee"),
  description: Yup.string(),
});

function convertMinutesToHHMMSS(minutes) {
  // Convert total minutes to seconds
  let totalSeconds = Math.floor(minutes * 60);

  // Calculate hours, minutes, and seconds
  let hours = Math.floor(totalSeconds / 3600);
  let remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
  let seconds = totalSeconds % 60;

  // Format with leading zeros
  let formattedTime =
    String(hours).padStart(2, "0") +
    ":" +
    String(remainingMinutes).padStart(2, "0") +
    ":" +
    String(seconds).padStart(2, "0");

  return formattedTime;
}

const LogForm = ({
  setOpen,
  prevData,
  setPrevData,
  task_id,
  initialValues,
  index,
  refetchData,
  dirtyFlag,
}) => {
  const [cookies] = useCookies(["euid"]);

  const initialData = {
    id: initialValues?.id || null,
    date: initialValues?.date || null,
    elapsed_time: initialValues?.elapsed_time || null,
    employee_id: cookies.euid,
    employee_name: decodeCookieValue(cookies.e_n),
    description: initialValues?.description || "",
  };

  const validationSchema = Yup.object().shape({
    date: Yup.date().required("Date is required"),
    elapsed_time: Yup.mixed().required("Elapsed time is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const newEntry = {
      id: initialData?.id,
      date: values.date,
      elapsed_time: values.elapsed_time,
      assignee: cookies.euid,
      employee_name: decodeCookieValue(cookies.e_n),
      description: values.description || "",
      employee_id: cookies.euid,
    };
  
    try {
      let res;
      if (initialValues?.id) {
        // Update existing entry
        res = await postData({
          endpoint: "TaskTimer/editTimerLog",
          params: { timerId: initialValues?.id },
          data: {
            ...values,
            assignee: cookies.euid,
            task_id: task_id,
            elapsed_time: values.elapsed_time,
          },
          token: cookies.e_t,
        });
  
        // Validate response
        if (res?.data?.status) {
          toast.success("Log updated successfully don't forget to Update log time in dsr", {
            duration: 2000,
            style: confimationStyles,
          });
        }
  
        const updatedLog = {
          ...newEntry,
          id: initialValues.id,
        };
  
        setPrevData((prev) =>
          prev.map((entry) =>
            entry.id === initialValues?.id ? updatedLog : entry
          )
        );

        dirtyFlag(true);
  
        // onLogSubmit(updatedLog, true);
        
      } else {
        // Add new entry
        res = await postData({
          endpoint: "TaskTimer/addTimerLog",
          data: {
            ...values,
            assignee: cookies.euid,
            task_id: task_id,
            elapsed_time: values.elapsed_time,
          },
          token: cookies.e_t,
        });

        if (res?.data?.status) {
          toast.success("Log added successfully don't forget to Update log time in dsr ", {
            style: confimationStyles,
            duration: 2000,
          });
        }
  
        const tempData = res?.data?.data;
        const newLog = {
          ...newEntry,
          id: tempData.id,
        };
  
        setPrevData([newLog, ...prevData]);
  
        // onLogSubmit(newLog, false);
        // toast.success("Log added successfully", {
        //   style: confimationStyles,
        //   duration: 1000,
        // });
      }
  
       dirtyFlag(true);
    } catch (err) {
      console.error("Error submitting log:", err);
      toast.error(err.message || "An error occurred while saving the log", {
        style: errorStyles,
        duration: 1000,
      });
    }
  
    resetForm();
    refetchData();
    setOpen(false);
  };

  return (
    <div>
      <Formik
        initialValues={initialData}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount
        validateOnChange
      >
        {({
          values,
          setFieldValue,
          handleChange,
          isSubmitting,
          resetForm,
          isValid,
          errors,
          touched,
          dirty,
        }) => (
          <Form>
            <div className="mb-3 d-flex align-items-center">
              <label className="w-40 font-medium">Date</label>
              <div className="w-60">
                <DateSelector
                  onChange={(date) => setFieldValue("date", date)}
                  selectedDate={initialData?.date}
                  disableFuture={true}
                />
              </div>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <label className="w-40 font-medium">Spent Time</label>
              <div className="w-60">
                <MuiTimePicker
                  onChange={(minutes) => {
                    setFieldValue(
                      "elapsed_time",
                      convertMinutesToHHMMSS(minutes)
                    );
                  }}
                  selectedTime={initialData?.elapsed_time}
                />
              </div>
            </div>

            <div className="mb-3 d-flex align-items-center">
              <label className="w-40 font-medium">Assignee</label>
              <div className="w-60">
                <input
                  value={decodeCookieValue(cookies.e_n)}
                  disabled
                  className="w-100"
                />
              </div>
            </div>

            <div className="d-flex flex-column mb-3">
              <label className="">Comment</label>
              <textarea
                name="description"
                id="description"
                value={values?.description}
                onChange={(e) => setFieldValue("description", e.target.value)}
                className="w-100"
              ></textarea>
            </div>

            <div className="modal-footer mt-4 px-4">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={
                  isSubmitting || !values.date || !values?.elapsed_time // Ensure fields are touched
                }
                onClick={() => handleSubmit(values, { resetForm })}
              >
                {initialValues ? "Update" : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const LogTime = ({ logData, setLogData, task_id, open, setOpen, name , refetchData , dirtyFlag , ispresent , mytask }) => {

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);


  const handleLogTimeClick = () => {
    if (ispresent || mytask) {
      setOpen(true); // Open LogForm
    } else {
      setIsDeleteModalOpen(true); // Open DeleteModal
    }
  };

  return (
    <>
      <CustomButton
        icon={<Hourglass size={14} />}
        text="Log Time"
        handleClick={handleLogTimeClick}
      />

      {open && (
        <Modal
          isActive={open}
          title={`Log time ${
            name
              ? `- ${name.length > 22 ? `${name.slice(0, 22)}...` : name}`
              : ""
          }`}
          width="500px"
          onClose={() => setOpen(false)}
        >
          <LogForm
            setOpen={setOpen}
            prevData={logData}
            setPrevData={setLogData}
            task_id={task_id}
            name={name}
            refetchData={refetchData}
            dirtyFlag={dirtyFlag}
          />
        </Modal>
      )}

      {isDeleteModalOpen && !ispresent && (
        <ConfirmModal
          title="Assigned Member"
          type="Not"
          isActive={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          description="Please got first assigned to this task then you can log the time"
          onClick={() => setIsDeleteModalOpen(false)}
        />
      )}
    </>
  );
};

export const LoggedEntries = ({ logData, setLogData, task_id , dirtyFlag , refetchData }) => {
  const [cookies] = useCookies([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState({});

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  // const formatTime = (timeString) => {
  //   const [hours, minutes, seconds] = timeString?.split(":").map(Number);
  //   const totalMinutes = hours * 60 + minutes + (seconds > 0 ? 1 : 0);

  //   const formattedHours = Math?.floor(totalMinutes / 60);
  //   const formattedMinutes = totalMinutes % 60;

  //   return formattedHours > 0
  //     ? `${formattedHours}h${
  //         formattedMinutes > 0 ? `${formattedMinutes}m` : ""
  //       }`
  //     : `${formattedMinutes}m`;
  // };

  const formatTime = (time) => {
    let totalSeconds = 0;

    if (typeof time === "string") {
      // Handle "HH:MM:SS" format
      const parts = time.split(":");
      if (parts.length === 3) {
        const hours = parseInt(parts[0], 10) || 0;
        const minutes = parseInt(parts[1], 10) || 0;
        const seconds = parseInt(parts[2], 10) || 0;
        totalSeconds = hours * 3600 + minutes * 60 + seconds;
      }
    } else if (typeof time === "number") {
      // Assume time is total seconds
      totalSeconds = time;
    }

    // Calculate total minutes, rounding up to nearest minute
    const totalMinutes = Math.ceil(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format the result
    return hours > 0
      ? `${hours}h ${minutes > 0 ? `${minutes}m` : ""}`
      : `${minutes}m`;
  };

  const handleLogDeletion = async () => {
    try {
      await deleteData({
        endpoint: "TaskTimer/deleteTimerLog",
        params: {
          timerId: selected?.id,
        },
      });
      toast.success("Log Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
      setIsDeleteModalOpen(false);
      setLogData((prev) => prev.filter((log) => log?.id !== selected?.id));
      refetchData();
      dirtyFlag(true);
    } catch (error) {
      toast.error("An Error Occured While Deleting", {
        style: errorStyles,
        duration: 1000,
      });
      console.log(error);
    }
  };

  return (
    <>
      <div className="logged-entries">
        {logData.map((item, index) => (
          <div className="log-item">
            <div className="log-info">
              <CircleAvatar name={item?.employee_name} size={40} />
              <div>
                <div>
                  <strong>{item.employee_name}</strong>
                  <div className="log-time-info">
                    {moment(item?.date).format("DD/MM/YYYY")}

                    <div className="dot"></div>

                    {formatTime(item?.elapsed_time)}
                  </div>

                  <div className="log-time-info">{item?.description}</div>
                </div>
              </div>
            </div>

            {cookies.euid === item?.employee_id && (
              <div className="log-icon-container">
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setOpen(true);
                    setSelected({ ...item, index });
                  }}
                >
                  <Edit2 size={18} />
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setIsDeleteModalOpen(true);
                    setSelected(item);
                  }}
                >
                  <Trash size={18} />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {open && (
        <Modal
          isActive={open}
          title={"Edit Log Time"}
          width="500px"
          onClose={() => setOpen(false)}
        >
          <LogForm
            setOpen={setOpen}
            prevData={logData}
            setPrevData={setLogData}
            task_id={task_id}
            initialValues={selected}
            dirtyFlag={dirtyFlag}
            refetchData={refetchData}
          />
        </Modal>
      )}

      {isDeleteModalOpen && (
        <DeleteModal
          title={"Log Time"}
          isActive={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          description={
            "Are you sure you want to delete this entry from the Log List"
          }
          onClick={handleLogDeletion}
        />
      )}
    </>
  );
};

export default LogTime;
